// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"9b350ebc","150":"9c6ee209","171":"63dd85d1","322":"d07229ee","352":"6822c1e4","453":"b8702c0f","485":"2c7244c0","583":"a1e05701","675":"6d50f559","678":"c94bc225","737":"46281479","781":"81b8d8d0","795":"63b58db5","857":"197f7474","935":"afe8ad22"}[chunkId] + ".chunk.js";
};